import { clamp } from 'lodash';

class SliderMapping {
	constructor (toSlider, fromSlider) {
		const privates = {
			toSlider,
			fromSlider,
		};
		this.toSlider = (val) => privates.toSlider(clamp(val, 0, 1));
		this.fromSlider = (val) => privates.fromSlider(clamp(val, 0, 1));
	}
}

const linear = SliderMapping.linear = new SliderMapping(
	(val) => val,
	(val) => val
);

const quadratic = SliderMapping.quadratic = new SliderMapping(
	(val) => Math.pow(val, 1 / 2),
	(val) => Math.pow(val, 2)
);

const cubic = SliderMapping.cubic = new SliderMapping(
	(val) => Math.pow(val, 1 / 3),
	(val) => Math.pow(val, 3)
);

function nic (exponent) {
	return new SliderMapping(
		(val) => Math.pow(val, 1 / exponent),
		(val) => Math.pow(val, exponent)
	);
};

export default SliderMapping;
export {
	linear,
	quadratic,
	cubic,
	nic,
};
